import React, { useState } from "react";
import CandidateFirstForm from "../candidate/candidate-first-form";
import CandidateSecondForm from "../candidate/candidate-second-form";
import CandidateThirdForm from "../candidate/candidate-third-form";
import CandidateDocumentForm from "../candidate/candidate-document-form";

const Candidature = () => {
  const [step, setStep] = useState(0);
  const [inputs, setInputs] = useState({});

  return (
    <section className="candidature" id="candidature">
      <div>
        <h1>Envie de nous rejoindre ?</h1>
        <p>Déposez votre candidature spontanée.</p>
        <div className="progress-bar">
          <div>
            <span className={"dot" + (step === 0 ? " focused-dot" : "")}>
              1
            </span>
            <p>Je choisis mon type de compte</p>
          </div>
          <span className="dash"></span>
          <div>
            <span
              className={"dot" + (step >= 1 && step < 3 ? " focused-dot" : "")}
            >
              2
            </span>
            <p>Je renseigne mes informations</p>
          </div>
          <span className="dash"></span>
          <div>
            <span className={"dot" + (step >= 3 ? " focused-dot" : "")}>3</span>
            <p>Je finalise et valide mon inscription</p>
          </div>
        </div>
      </div>
      <div>
        {step === 0 && (
          <CandidateFirstForm
            setInputs={setInputs}
            setStep={setStep}
            inputs={inputs}
          />
        )}
        {step === 1 && (
          <CandidateSecondForm
            setInputs={setInputs}
            setStep={setStep}
            inputs={inputs}
          />
        )}
        {step === 2 && (
          <CandidateThirdForm
            setInputs={setInputs}
            setStep={setStep}
            inputs={inputs}
          />
        )}
        {step === 3 && (
          <CandidateDocumentForm
            setInputs={setInputs}
            setStep={setStep}
            inputs={inputs}
          />
        )}
      </div>
    </section>
  );
};

export default Candidature;
